import { initTracking, resetAnalytics } from './AnalyticsUtils';
import { useEffect } from 'react';

export const Analytics = () => {
	useEffect(() => {
		initTracking();

		return () => {
			// ensure reset only happens after init
			resetAnalytics();
		};
	}, []);

	return null;
};

Analytics.displayName = 'Analytics';
